// extracted by mini-css-extract-plugin
export default {"row":"specification-form-item_row__ws8hD","rowHalf":"specification-form-item_rowHalf__t6jkq"};